import React from 'react';
import { useHistory } from 'react-router-dom';

import { locale } from '@trqk/utils';
import { Button } from '@trqk/components';

import { HASHES, PATHS } from '../../../constants';

interface PlanExpiredInput {
    /**
     * Invoked when the user clicks the button to update their payment plan.
     * @returns undefined
     */
    onNavigate: () => void;
    /**
     * Concatenated with the message shown to the user to indicate whether they are uploading
     * statements or audio files.
     */
    fileType: 'statements' | 'audio files';
}

/**
 * A toast message shown when the user tries to upload a statement or audio file but their payment
 * plan has expired.
 */
export const PlanExpired = ({
    remove,
    input,
}: ToastRenderContentProps<PlanExpiredInput>): JSX.Element => {
    const history = useHistory();

    return (
        <div style={{ width: 500 }} className="px-2">
            <div className="mb-1 font-bold tracking-wider text-highlight-orange">
                {locale.enUS.INGESTION.TOASTS.PLAN_EXPIRED.TITLE}
            </div>
            <div className="mt-2 mb-6">
                {`${locale.enUS.INGESTION.TOASTS.PLAN_EXPIRED.PLEASE_UPDATE_YOUR_PLAN} ${input?.fileType}.`}
            </div>
            <Button
                autoWidth={true}
                color="primary"
                handleClick={() => {
                    // Remove this toast
                    remove();

                    // Invoke callback, typically to close the modal that is open when this toast
                    // is shown.
                    if (input?.onNavigate) {
                        input.onNavigate();
                    }

                    // This setTimeout seems necessary to prevent the Settings page from scrolling
                    // to the wrong section when the user clicks the button.
                    setTimeout(() => {
                        // Go to the Settings page
                        history.push({
                            search: history.location.search,
                            pathname: PATHS.SETTINGS,
                            hash: HASHES.SETTINGS.PAYMENT_PLAN,
                            state: {
                                fromLink: true,
                            },
                        });
                    }, 500);
                }}
            >
                {locale.enUS.INGESTION.TOASTS.PLAN_EXPIRED.UPDATE_PLAN}
            </Button>
        </div>
    );
};
